module.exports = __webpack_public_path__ + "static/backtest_icon-425774dfecfb5ddf13792d0d295f71e7.svg";